"use client";
import React from "react";
import { FormikProvider } from "formik";
import { AppFormProps } from "types/provider/Form";
export {
  useFormik,
  useField,
  useFormikContext as useFormContext,
} from "formik";
export { default as Yup } from "utils/yup";

const FormProvider = ({ children, form }: AppFormProps) => {
  // Ép kiểu form thành FormikContextType<any> để phù hợp với yêu cầu của FormikProvider
  return <FormikProvider value={form as any}>{children}</FormikProvider>;
};

export default FormProvider;
